var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11,12c0,1.379-1.122,2.5-2.5,2.5-1.402,0-2.5-1.148-2.5-2.615v-4.885h-.274c-1.339,0-2.508.905-2.843,2.202l-1.086,4.208-1.175,1.175-.707-.707.982-.982,1.019-3.943c.449-1.738,2.016-2.952,3.811-2.952h.274v-.615c0-1.653,1.208-3.164,2.873-3.594l3.656-.854L13.474-.007l.707.707-1.147,1.146-3.922.916c-1.219.314-2.111,1.419-2.111,2.623v6.5c0,.921.645,1.615,1.5,1.615.827,0,1.5-.673,1.5-1.5v-5h1v2h7.802l1.76-1.653.685.729-2.048,1.924h-8.198v2Zm13,5.5c0,3.584-2.916,6.5-6.5,6.5s-6.5-2.916-6.5-6.5,2.916-6.5,6.5-6.5,6.5,2.916,6.5,6.5Zm-1,0c0-3.032-2.467-5.5-5.5-5.5s-5.5,2.468-5.5,5.5,2.467,5.5,5.5,5.5,5.5-2.468,5.5-5.5Zm-6.02,1.451c-.055.057-.179.057-.241-.006l-1.856-1.8-.696.719,1.851,1.794c.221.221.514.342.825.342s.604-.121.822-.339l3.457-3.399-.701-.713-3.46,3.402Zm-8.69.549l-1.809,1.827.715.699,1.458-1.49.913-.004c-.128-.334-.235-.678-.32-1.032h-.956Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrust);
export default __webpack_public_path__ + "static/media/trust.24ebb6878b6150883af736dd39931558.svg";
export { ForwardRef as ReactComponent };